export enum AgentChatContextEnum {
  NoOffer = 'Użytkownik nie jest na żadnej ofercie',
  OnOffer = 'Użytkownik jest na ofercie',
}
